import { render } from "./BluePill.vue?vue&type=template&id=b19cc266&scoped=true"
import script from "./BluePill.vue?vue&type=script&lang=js"
export * from "./BluePill.vue?vue&type=script&lang=js"

import "./BluePill.vue?vue&type=style&index=0&id=b19cc266&lang=scss&scoped=true"

import exportComponent from "/var/www/ascentcontrols/landingpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b19cc266"]])

export default __exports__